export default "__VITE_ASSET__2d02994a__"